import type { FC, ReactNode } from 'react';

import { StyledTourCardContainer } from './StyledComponents';

interface TourCardContainerProps {
  hasBigBottomBorder?: boolean;
  size?: 'sm' | 'md';
  isSelected?: boolean; // adds shadow
  children: ReactNode;
}

const TourCardContainer: FC<TourCardContainerProps> = ({
  hasBigBottomBorder = false,
  size = 'sm',
  isSelected = false,
  children,
}) => (
  <StyledTourCardContainer size={size} hasBigBottomBorder={hasBigBottomBorder} isSelected={isSelected}>
    {children}
  </StyledTourCardContainer>
);

export type { TourCardContainerProps };
export default TourCardContainer;
